var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _vm.loading.value
        ? _c(
            "v-card",
            { staticClass: "d-flex justify-center", attrs: { flat: "" } },
            [
              _c(
                "v-card",
                { staticClass: "py-4", attrs: { width: "600", flat: "" } },
                [
                  _c(
                    "v-card-text",
                    [
                      _vm._v(" " + _vm._s(_vm.loading.text) + " "),
                      _c("v-progress-linear", {
                        attrs: {
                          color: "secondary",
                          striped: "",
                          value: _vm.loading.value,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : [
            _c(
              "v-row",
              { attrs: { dense: "" } },
              [
                _vm.page === "sse"
                  ? _c(
                      "v-col",
                      { attrs: { sm: "3" } },
                      [
                        _vm.page === "sse"
                          ? _c("v-select", {
                              attrs: {
                                label: "Project",
                                items: _vm.projectItems,
                                dense: "",
                              },
                              model: {
                                value: _vm.computedSettings.project,
                                callback: function ($$v) {
                                  _vm.$set(_vm.computedSettings, "project", $$v)
                                },
                                expression: "computedSettings.project",
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "v-col",
                  [
                    _c(
                      "v-btn-toggle",
                      {
                        attrs: { mandatory: "", color: "primary", dense: "" },
                        model: {
                          value: _vm.computedSettings.viewMode,
                          callback: function ($$v) {
                            _vm.$set(_vm.computedSettings, "viewMode", $$v)
                          },
                          expression: "computedSettings.viewMode",
                        },
                      },
                      _vm._l(_vm.computedRadioButton, function (button) {
                        return _c(
                          "v-tooltip",
                          {
                            key: button.value,
                            attrs: { top: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function (ref) {
                                    var on = ref.on
                                    return [
                                      _c(
                                        "v-btn",
                                        _vm._g(
                                          {
                                            attrs: {
                                              text: "",
                                              value: button.value,
                                              small: "",
                                            },
                                          },
                                          on
                                        ),
                                        [
                                          _vm._v(
                                            " " + _vm._s(button.label) + " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          },
                          [
                            _c("span", [
                              _vm._v(
                                "Display " + _vm._s(button.label) + " results"
                              ),
                            ]),
                          ]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _vm.page === "pf" &&
                _vm.dates &&
                _vm.settings.viewMode === "timeSeries"
                  ? [
                      _c("v-spacer"),
                      _c(
                        "v-btn-toggle",
                        {
                          attrs: { mandatory: "", dense: "" },
                          model: {
                            value: _vm.computedSettings.pfTimeSeriesOutputType,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.computedSettings,
                                "pfTimeSeriesOutputType",
                                $$v
                              )
                            },
                            expression:
                              "computedSettings.pfTimeSeriesOutputType",
                          },
                        },
                        [
                          _c(
                            "v-tooltip",
                            {
                              attrs: { top: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function (ref) {
                                      var on = ref.on
                                      return [
                                        _c(
                                          "v-btn",
                                          _vm._g(
                                            {
                                              attrs: {
                                                text: "",
                                                value: "dashboard",
                                              },
                                            },
                                            on
                                          ),
                                          [
                                            _c("v-icon", [
                                              _vm._v("mdi-view-dashboard"),
                                            ]),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                4080361932
                              ),
                            },
                            [_c("span", [_vm._v("Dashboard")])]
                          ),
                          _c(
                            "v-tooltip",
                            {
                              attrs: { top: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function (ref) {
                                      var on = ref.on
                                      return [
                                        _c(
                                          "v-btn",
                                          _vm._g(
                                            {
                                              attrs: {
                                                text: "",
                                                value: "tabular",
                                              },
                                            },
                                            on
                                          ),
                                          [
                                            _c("v-icon", [
                                              _vm._v("mdi-view-list"),
                                            ]),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                4266207859
                              ),
                            },
                            [_c("span", [_vm._v("Tabular")])]
                          ),
                        ],
                        1
                      ),
                    ]
                  : _vm._e(),
              ],
              2
            ),
            _vm.dates && ["daily", "monthly"].includes(_vm.settings.viewMode)
              ? _c(
                  "v-row",
                  { attrs: { dense: "" } },
                  [
                    ["daily", "monthly"].includes(_vm.settings.viewMode)
                      ? _c(
                          "v-col",
                          { staticClass: "py-0", attrs: { sm: "3" } },
                          [
                            _c("v-select", {
                              attrs: {
                                label: "Year",
                                items: _vm.yearItems,
                                multiple: "",
                              },
                              model: {
                                value: _vm.computedSettings.selectedYear,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.computedSettings,
                                    "selectedYear",
                                    $$v
                                  )
                                },
                                expression: "computedSettings.selectedYear",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
            _vm.dates && _vm.settings.viewMode === "timeSeries"
              ? _c(
                  "v-row",
                  { staticClass: "mt-0", attrs: { dense: "" } },
                  [
                    _c(
                      "v-col",
                      { staticClass: "py-0", attrs: { sm: "3" } },
                      [
                        _c(
                          "v-radio-group",
                          {
                            attrs: {
                              disabled: _vm.settings.viewMode !== "timeSeries",
                              row: "",
                            },
                            model: {
                              value: _vm.dateMode,
                              callback: function ($$v) {
                                _vm.dateMode = $$v
                              },
                              expression: "dateMode",
                            },
                          },
                          [
                            _c("v-radio", {
                              attrs: { label: "Single Day", value: "single" },
                            }),
                            _c("v-radio", {
                              attrs: { label: "Range", value: "range" },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { staticClass: "py-0", attrs: { sm: "3" } },
                      [
                        _vm.dateMode === "range"
                          ? _c("InputDateRange", {
                              attrs: {
                                label: "Dates",
                                disabled:
                                  _vm.settings.viewMode !== "timeSeries",
                              },
                              model: {
                                value: _vm.computedDates,
                                callback: function ($$v) {
                                  _vm.computedDates = $$v
                                },
                                expression: "computedDates",
                              },
                            })
                          : _c("InputDate", {
                              attrs: {
                                label: "Date",
                                disabled:
                                  _vm.settings.viewMode !== "timeSeries",
                              },
                              on: { input: _vm.setDates },
                              model: {
                                value: _vm.computedDates[0],
                                callback: function ($$v) {
                                  _vm.$set(_vm.computedDates, 0, $$v)
                                },
                                expression: "computedDates[0]",
                              },
                            }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { staticClass: "py-0", attrs: { sm: "6", cols: "12" } },
                      [
                        _vm.dateMode === "single"
                          ? _c("InputDatePlayControls", {
                              attrs: {
                                playMode: _vm.playMode,
                                "time-interval": _vm.settings.timeInterval,
                                disabled:
                                  _vm.settings.viewMode !== "timeSeries",
                              },
                              on: {
                                "update:playMode": function ($event) {
                                  _vm.playMode = $event
                                },
                                "update:play-mode": function ($event) {
                                  _vm.playMode = $event
                                },
                                input: _vm.setDates,
                              },
                              model: {
                                value: _vm.computedDates[0],
                                callback: function ($$v) {
                                  _vm.$set(_vm.computedDates, 0, $$v)
                                },
                                expression: "computedDates[0]",
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _c("v-divider", { staticClass: "mb-4" }),
            _vm.settings.viewMode !== "violationReport" &&
            _vm.settings.viewMode !== "contingency" &&
            _vm.disableResourceItem
              ? _c(
                  "v-row",
                  { attrs: { dense: "" } },
                  [
                    _vm._l(_vm.resourcesItems, function (items, key) {
                      return [
                        items.length
                          ? _c(
                              "v-col",
                              { key: key, attrs: { sm: "3" } },
                              [
                                _c("v-select", {
                                  attrs: {
                                    label: _vm.selectLabel(key),
                                    items: items,
                                    multiple: "",
                                    dense: "",
                                  },
                                  model: {
                                    value: _vm.computedSettings[key],
                                    callback: function ($$v) {
                                      _vm.$set(_vm.computedSettings, key, $$v)
                                    },
                                    expression: "computedSettings[key]",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]
                    }),
                  ],
                  2
                )
              : _vm._e(),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }